import React, { useState } from 'react';
import { Grid, Tooltip } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import OutlinedFlagRoundedIcon from '@mui/icons-material/OutlinedFlagRounded';
import { useSelector } from 'react-redux';
import DateRange from '#component/general/date-range/date-range-router';
import OverviewActions from '#component/warehouse/appliance-overview/overview-actions';
import DateRangeControls from '#component/general/date-range/date-range-controls';
import {
  HeaderGrid,
  ApplianceHeader,
  ApplianceUIDContainer,
  ApplianceUIDTooltip,
  ApplianceUIDLabel,
  ApplianceInfoLabel,
  ButtonRoot,
  ApplianceLabel,
  WarningContainer,
  StyledWarningIcon,
  ApplianceLabelText,
  DateRangeArea
} from '#component/warehouse/appliance-overview/style';

const STOPPED_STATUS = 300;

function Header(props) {
  const {
    dispatch,
    userType,
    account,
    history,
    appliance,
    rangeStart,
    rangeEnd,
    setDateRange,
    timeoutAlerts,
    isInRange,
    devicesWithExcursions,
    selectedDevices,
    openEndDateDialog,
    setOpenEndDateDialog
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const applianceFromStore =
    useSelector(state => state.appliances.appliances.find(a => a.id === appliance.id));
  const isApplianceStopped = (applianceData, applianceDataromStore) =>
    applianceData?.status === STOPPED_STATUS || applianceDataromStore?.status === STOPPED_STATUS;

  const minDate = appliance.creationDate ?
    new Date(new Date(appliance.creationDate).setUTCHours(0, 0, 0, 0)).toISOString() : null;

  const maxDate = appliance.stoppedDate ?
    new Date(new Date(appliance.stoppedDate).setUTCHours(0, 0, 0, 0)).toISOString() :
    new Date().toISOString();

  const warningMessages = [];
  if (timeoutAlerts.length) warningMessages.push('A device has more than 4 hours time delay.');
  if (devicesWithExcursions.length) warningMessages.push('Detected a measurement excursion.');

  return (
    <HeaderGrid container spacing={2} id="overviewHeader">
      <Grid item xs={12} sm={5} md={6}>
        <ApplianceHeader>
          <ApplianceUIDContainer variant="overline" gutterBottom>
            {appliance.uid && (
            <ApplianceUIDTooltip
              placement="bottom-start"
              title={appliance.uid}
            >
              <ApplianceUIDLabel>
                {`APPLICATION-ID: ${appliance.uid}`}
              </ApplianceUIDLabel>
            </ApplianceUIDTooltip>)}
            {appliance?.project && <ApplianceInfoLabel aria-label="Appliance project">{`PROJECT: ${appliance.project.title}`}</ApplianceInfoLabel>}
            {appliance?.warehouse && <ApplianceInfoLabel aria-label="Appliance site">{`SITE: ${appliance.warehouse.label}`}</ApplianceInfoLabel>}
          </ApplianceUIDContainer>
          <ButtonRoot onClick={e => setAnchorEl(e.currentTarget)}>
            {isApplianceStopped(appliance, applianceFromStore) &&
              <Tooltip title="Stopped">
                <OutlinedFlagRoundedIcon />
              </Tooltip>}
            <ApplianceLabel variant="h5" gutterBottom>
              <WarningContainer>
                {warningMessages.length ?
                  <Tooltip title={warningMessages.map(m => (<div>{m}</div>))}>
                    <StyledWarningIcon />
                  </Tooltip> : null}
              </WarningContainer>
              <ApplianceLabelText>
                {appliance.label}
              </ApplianceLabelText>
            </ApplianceLabel>
            {userType < 20 &&
              <ArrowDropDown />}
          </ButtonRoot>
        </ApplianceHeader>
      </Grid>
      <DateRangeArea item xs={12} sm={7} md={6}>
        <DateRangeControls
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minDate}
          maxDate={maxDate}
          isInRange={isInRange}
          totalMonthRange={1}
        />
        <DateRange
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minDate}
          maxDate={maxDate}
          isInRange={isInRange}
          totalMonthRange={1}
          openEndDateDialog={openEndDateDialog}
          setOpenEndDateDialog={setOpenEndDateDialog}
        />
        <DateRangeControls
          rangeStart={rangeStart.toISOString()}
          rangeEnd={rangeEnd.toISOString()}
          setDateRange={setDateRange}
          minDate={minDate}
          maxDate={maxDate}
          isInRange={isInRange}
          totalMonthRange={1}
          mode="update"
        />
      </DateRangeArea>

      <OverviewActions
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        appliance={appliance}
        userType={userType}
        history={history}
        account={account}
        dispatch={dispatch}
        selectedDevices={selectedDevices}
        dateRange={{ start: rangeStart, end: rangeEnd }}
      />
    </HeaderGrid>
  );
}

export default Header;
